export const FEATURE_FLAGS = {
    feature_collection: 'beta',
    metric_enabled: 'on',
    live_event: 'off',
    'kiosk-unity': 'on',
    lab: 'on',
    'unity-simulator': 'on',
} as const

export default FEATURE_FLAGS
